module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-3d-container",
    style: ({
      height: this.slideHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "carousel-3d-slider",
    style: ({
      width: this.slideWidth + 'px',
      height: this.slideHeight + 'px',
    })
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.controlsVisible) ? _c('controls', {
    attrs: {
      "next-html": _vm.controlsNextHtml,
      "prev-html": _vm.controlsPrevHtml,
      "width": _vm.controlsWidth,
      "height": _vm.controlsHeight
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35bd76f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/Carousel3d.vue
// module id = 1679
// module chunks = 180